import ScrollMagic from 'scrollmagic';

export default function pins() {

    $(window).on('load', function () {

        if ($('._fixed-background').length > 0) {

            let fixedBackgroundController = new ScrollMagic.Controller();

            function backgroundPinsInit() {
                $('._fixed-background').each(function () {
                    let $this = $(this),
                        scrollOffset = $this.innerHeight(),
                        sectionHeight = $this.parents('.section-direction').innerHeight(),
                        // headingHeight = $this.parents('.section-direction').find('.section-direction__heading').innerHeight(),
                        duration = sectionHeight - scrollOffset - 203;

                    if (duration < 0) {
                        duration = 1;
                    }

                    let fixedBackground = new ScrollMagic.Scene({
                        duration: duration,
                        offset: scrollOffset,
                        triggerElement: this,
                        triggerHook: 1,
                    })
                        .addTo(fixedBackgroundController);
                    fixedBackground.setPin(this);

                    // if ($(window).width() < 1200) {
                    //     // let duration = sectionHeight - scrollOffset - headingHeight + 8;
                    //     fixedBackground.duration(duration);
                    // }
                    // if ($(window).width() < 1024) {
                    //     // let duration = sectionHeight - scrollOffset - headingHeight - 80;
                    //     fixedBackground.duration(duration);
                    // }
                    if ($(window).width() < 768) {
                        fixedBackground.removePin(this);
                    }

                    $('.footer').css('marginTop', '0');
                });
            }

            backgroundPinsInit();
        }

    });
}